import { render, staticRenderFns } from "./ajFormAdd.vue?vue&type=template&id=26d67cc2"
import script from "./ajFormAdd.vue?vue&type=script&lang=js"
export * from "./ajFormAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports